import { range } from 'ramda';

export const parsePlayerFields = (playerFields) => {
    const playerFieldsArray = playerFields?.replace(/\s/g, '')
        .split(',')
        .filter(Boolean)
        .map(item => parseInt(item));

    if (!playerFieldsArray.length) {
        return null;
    }

    return playerFieldsArray;
};

export const getDefaultPlayerFields = () => {
    let playerFields = range(1, 43);

    playerFields = playerFields.concat(range(44, 50));
    playerFields = playerFields.concat(range(51, 62));
    // get custom fields
    playerFields = playerFields.concat(range(73, 85));
    // additional fields for NetVerify/Jumio
    playerFields.push(89, 104, 123, 145);
    // playerCode
    playerFields.push(103, 111, 115);
    // get player's 'IBAN' value
    playerFields.push(153);
    // phoneVerified
    playerFields.push(160);
    // additional fields for activeIDToken
    playerFields.push(164);
    // userId
    playerFields.push(182);
    // loginName
    playerFields.push(184);

    return playerFields;
};
